import React, { useState, useEffect, useContext } from "react";
import CartModal from "../modal/CartModal";
import { FarzaaContext } from "../../context/FarzaaContext";

const HeaderRightContent = () => {
  const [cartItems, setCartItems] = useState([]);
  const [cartItemAmount, setCartItemAmount] = useState(0);
  const [showCart, setShowCart] = useState(false);

  const getCookie = (name) => {
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let c = cookies[i].trim();
      if (c.indexOf(name + "=") === 0) {
        return c.substring(name.length + 1, c.length);
      }
    }
    return "";
  };

  useEffect(() => {
    const cartFromCookie = getCookie('cartItems');
    if (cartFromCookie) {
      const parsedCart = JSON.parse(cartFromCookie);
      setCartItems(parsedCart);

      const totalAmount = parsedCart.reduce((acc, item) => acc + item.quantity, 0);
      setCartItemAmount(totalAmount);
    }
  }, []);

  const {
    handleCartShow,
  } = useContext(FarzaaContext);

  return (
    <>
      <div className="fz-header-right-content">
        <ul className="fz-header-right-actions d-flex align-items-center justify-content-end">
          <li>
            <button
              className="fz-header-cart-btn d-none d-lg-block"
              onClick={handleCartShow}
            >
              <i className="fa-light fa-shopping-bag"></i>
              <span className="count">{cartItemAmount}</span>
            </button>
          </li>
          <li className="fz-header-cart-btn d-block d-lg-none">
            <a
              role="button"
              onClick={handleCartShow}
              className="fa-light fa-shopping-bag"
            >
              <span className="count">{cartItemAmount}</span>
            </a>
          </li>
        </ul>
      </div>

      <CartModal cartArray={cartItems} showCart={showCart} />
    </>
  );
};

export default HeaderRightContent;
